<template>
    <div>
        <!-- <div style="position: absolute;top: 0;">
        </div>
        <div
            style="position: absolute;bottom: 20px;width: 100%;text-align: center;"
        >
            <img
                style="width: 90px;"
                class="img-bg"
                src="@/assets/LogoBzbs.svg"
            />
        </div> -->
    </div>
</template>
<script>
import Account from "@/helper/AccountHelper.js";
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
/**
 * @event switchLang
 * @event logout
 * @property {object} lbl (require)
 * @property {string} activeTab (optional)
 * @property {object} profile (require)
 * @property {boolean} isLogin (require)
 * @property {ModalController} modalController (optional)
 */
export default {
    name: "top-bar", // <top-bar>
    mixins: [AccountMixin, LocaleMixin],
    props: {
        activeTab: String,
        modalController: Object
    },
    data: function() {
        return {
            confirmModal: null
        };
    },
    created: function() {
        // console.log(this.profile);
        if (this.modalController != null) {
            this.confirmModal = this.modalController.confirmModal;
        }
    },
    methods: {
        initial: function() {},

        // switchLang: function(locale) {
        //     this.$emit('switchLang', locale);
        // },

        clickLogout: function() {
            this.modalController.confirmModal
                .clearModal()
                .setTitle("Logout?")
                .setMsg("You need logout?")
                .setBtnOk("Logout")
                .setBtnCancel("No")
                .show();
            this.confirmModal.onClickOk(() => {
                this.logout();
            });
        },

        logout: function() {
            Account.setLogout().then(
                () => {
                    window.location.reload();
                },
                () => {
                    window.location.reload();
                }
            );
        },

        goto(page) {
            this.$router.push("/" + page);
        }
    }
};
</script>
